<template>
  <div class="blinki-input">
    <div class="flex blinki-input">
      <label class="typo__label blinki-textarea-label no-dhtmlx">{{title}}
      <span class="main-color" v-if="required">(*)</span>
      </label>
    </div>
    <template v-if="!custom">
      <input  v-model="listLocal" :required="required" style="height: 0; border: none; width: 0;display: block;"/>
      <multiselect v-model="listLocal" :options="options" :multiple="multiple" :close-on-select="!multiple"
                   :clear-on-select="false"
                   :preserve-search="true"
                   v-on:open="open($event)"
                   selectLabel=""
                   deselectLabel=""
                   v-bind="$attrs"
                   selectedLabel="sélectionnée"
                   :placeholder="Localplaceholder" label="text" track-by="value" :preselect-first="false">
      </multiselect>
    </template>
    <template v-else>
      <input  v-model="listLocal" :required="required" style="height: 0; border: none; width: 0;display: block;"/>
      <multiselect v-model="listLocal" :options="options" :multiple="multiple" :close-on-select="!multiple"
                   :clear-on-select="false"
                   :preserve-search="true"
                   v-on:open="open($event)"
                   selectLabel=""
                   deselectLabel=""
                   selectedLabel="sélectionnée"
                   v-bind="$attrs"
                   :placeholder="Localplaceholder" :preselect-first="false">
        <span slot="noOptions">La liste est vide</span>
        <template slot="selection" slot-scope="{ values, search, isOpen }">
                  <span class="multiselect__single" v-if="false">
                    {{ values.length }} options sélectionnées
                  </span>
        </template>
        <span slot="noResult">Pas de résultat</span>
      </multiselect>
    </template>
  </div>
</template>

<script>
  export default {
    name: "custom-select",
    data() {
      return {
      }
    },
    props: [
      'title',
      'options',
      'values',
      'list',
      'multiple',
      'no_enter',
      'required',
      'filter',
      'jquery_id',
      'placeholder',
      'custom'
    ],
    model: {
      prop: 'list',
      event: 'listChange'
    },
    mounted(){
      this.enter();
    },
    methods: {
      open(id=-1){},
      enter(){
        if(this.filter) {
          this.input.keyup((e) => {
            if(!this.multiple && e.target.value && this.listLocal)
            this.listLocal =  {value: 0, text: e.target.value, item: {}};
          })
        }
      }
    },
    watch:{
      listLocal:{
        handler: function(val, oldVal) {
          if(this.filter) {
            this.$emit('listChange', val)
          }
        },
        deep: true
      }
    },
    computed: {
      listLocal: {
        get: function () {
          return this.list
        },
        set: function (value) {
          this.$emit('listChange', value)
        }
      },
      input(){
        return $((this.jquery_id ? '#'+this.jquery_id+' ' : '') +'.multiselect__input');
      },
      Localplaceholder(){
        return this.placeholder || 'Choisissez quelques uns'
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~/assets/css/theme.scss';

  .blinki-input > .b-icon {
    top: 14px;
    right: 8px;
  }

  /deep/ .multiselect{
    border-top: none;
    border-right: none;
    border-left: none;
    border-radius: 0;
    border-bottom: 2px solid $main-color;
    padding-left: 0;
  }

  /deep/ .multiselect__tags{
    background-color: transparent !important;
    border: 0 !important;
    padding-top: 12px !important;
  }

  /deep/ .multiselect--disabled {
    background : #ffffff00;
    .multiselect__select {
      display: none;
    }
  }


</style>
